import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { ScheduleInterval } from "common/types";

import DesktopLayout from "./DesktopLayout";
import MobileLayout from "./MobileLayout";

interface ScheduleItemProps {
  day: string;
  ranges: ScheduleInterval[];
  isDisabled: boolean;
  setRanges: (ranges: ScheduleInterval[]) => void;
  onApplyToAll: (ranges: ScheduleInterval[]) => void;
}

export default function ScheduleItem(props: ScheduleItemProps) {
  const isDesktop = useTwBreakpoint("lg");

  const Component = isDesktop ? DesktopLayout : MobileLayout;
  return <Component {...props} />;
}
